import { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import useApi from "../../hooks/useApi";
import useLocalization from "../../hooks/useLocalization";
import useData from "../../hooks/useData";

import GroupedQuestions from "./GroupedQuestions";
import Select from "../elements/Select";
import Input from "../elements/Input";

const QuestionOptions = ({ question, value, onChange }) => {
  const { getLabel } = useLocalization();

  const handleChange = (newValue) => {
    onChange(newValue);
  };

  return (
    <Box width="200px">
      <Select
        id="questionoptions"
        label={getLabel("options")}
        value={value ? value : []}
        items={Array.isArray(question?.options) ? question.options : []}
        multiSelect={true}
        darkSelectedItems={true}
        onChange={(newValue) => handleChange(newValue)}
      />
    </Box>
  );
};

const Logic = ({
  entityName,
  surveyId,
  page,
  section,
  question,
  value,
  onChange,
}) => {
  const theme = useTheme();
  const { postData } = useApi();
  const { getLabel, getMessage } = useLocalization();
  const { findOne } = useData();

  const [questions, setQuestions] = useState(null);
  const [sections, setSections] = useState(null);

  useEffect(() => {
    getLogicQuestions();
  }, [value]);

  const getLogicQuestions = async () => {
    if (!surveyId) return;

    const results = await postData({
      entityName: entityName,
      action: "logicQuestions",
      data: {
        surveyId,
        forPage: page,
        forSection: section,
        forQuestion: question,
      },
    });

    if (results.isSuccessful) {
      setQuestions(results.data.questions);
      setSections(results.data.sections);
    }
  };

  const handleQuestionChange = (questionId) => {
    if (questionId === "notset" || !questionId) {
      onChange(null);
    } else {
      onChange({ questionId, value: [] });
    }
  };

  const handleOptionChange = (newOptions) => {
    if (!value.questionId) {
      return;
    }

    onChange({ questionId: value.questionId, value: newOptions });
  };

  const getQuestion = () => {
    if (!value.questionId) {
      return null;
    }

    const question = findOne(questions, { _id: value.questionId });

    return question;
  };

  return (
    <Box
      width="100%"
      marginTop="8px"
    >
      {Array.isArray(questions) && questions.length > 0 ? (
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          gap={1}
        >
          <GroupedQuestions
            label={getLabel("controlledBy")}
            sections={sections}
            questions={questions}
            value={value?.questionId}
            onChange={handleQuestionChange}
          />

          {value?.questionId ? (
            <QuestionOptions
              question={getQuestion()}
              value={value?.value}
              onChange={handleOptionChange}
            />
          ) : null}
        </Box>
      ) : (
        <Input
          label={getLabel("controlledBy")}
          value={getMessage("noAvailableQuestions")}
          disabled
          fullwidth
        />
      )}
    </Box>
  );
};

export default Logic;
